import React from 'react';
import { VStack, Text } from '@chakra-ui/react';
import { Button } from '../../../UI-CHAKRA/Button';
import BaseDialog from '../../../Dialogs/BaseDialog';
import Perdidex from '../../../../assets/images/perdidex.svg';

interface IncompletePrescriptionsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

function IncompletePrescriptionsModal({ isOpen, onClose }: IncompletePrescriptionsModalProps) {
  return (
    <BaseDialog isOpen={isOpen} onClose={onClose} width="400px" persist={false}>
      <VStack spacing="24px" align="center" textAlign="center" py="20px">
        <img src={Perdidex} alt="Ícone de aviso" />
        <Text fontSize="24px" fontWeight="700" color="#3D0E6B" lineHeight="28px">
          Algumas prescrições parecem incompletas
        </Text>

        <Text fontSize="16px" fontWeight="400" color="#666666" lineHeight="20px" maxW="320px">
          Verifique a lista de prescrições e se necessário edite-as.
        </Text>

        <Button
          width="100%"
          height="48px"
          bg="#3D0E6B"
          color="white"
          borderRadius="24px"
          fontWeight="600"
          fontSize="16px"
          onClick={onClose}
          _hover={{
            bg: '#2D0A4F',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 12px rgba(61, 14, 107, 0.3)',
          }}
          _active={{
            transform: 'translateY(0px)',
            bg: '#1F0735',
          }}
          transition="all 0.2s cubic-bezier(0.4, 0, 0.2, 1)"
        >
          Entendi
        </Button>
      </VStack>
    </BaseDialog>
  );
}

export { IncompletePrescriptionsModal };
